<template>
  <div>
    <!-- <img v-if="imgList.img" class="tui-img" :src="imgList.img" alt=""> -->
    <div class="bigBox">
      <div class="searchBox">
        <kind-choose-view :ifImg="false" @isOk="isOk" />
      </div>
      <div class="courseList">
        <div v-for="item in list" :key="item.id" class="courstItem" @click="goDetail(item)">
          <img class="itemImg" :src="item.surfacePlot">
          <div class="contentItem">
            <div class="titleItem">{{ item.openCourseName }}</div>
            <div class="timeItem">
              <span>直播时间：{{ item.liveStartTime }}</span>
            </div>
            <div class="line" />
            <div class="teacherItem">
              <div class="itemBox">
                <img v-if="item.teacherPortrait" class="teacherImgItem" :src="item.teacherPortrait">
                <div v-if="item.teacherName" class="ter_name">
                  讲师：{{ item.teacherName }}
                </div>
              </div>
              <div>查看详情></div>
            </div>
          </div>
        </div>
      </div>
      <el-pagination class="pagination" :current-page="page.pageNum" :page-sizes="[12, 24, 36, 48]"
        :page-size="page.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="page.total"
        @size-change="handleSizeChange" @current-change="handleCurrentChange" />
    </div>
  </div>
</template>

<script>
import KindChooseView from '@/components/kindChooseViews.vue'
import Vue from 'vue'
import { getInfo, getDomain } from '@/api/cookies'

import { HomeClient } from "@/api/home";
const homeClient = new HomeClient();
export default {
  components: {
    KindChooseView
  },
  data() {
    return {
      page: {
        pageSize: 12,
        pageNum: 1,
        total: 0
      },
      list: [],
      searchForm: {},
      userInfo: null,
      liveTodayList: [],
      imgList: {},
      a: {},
      domain: null
    }
  },
  async created() {
    this.domain = getDomain()
    this.getList()
    this.userInfo = await getInfo()
    this.getImg()
  },
  methods: {

    isOk(val) {
      this.searchForm.belongProjectId = val.kind
      this.searchForm.belongCollegeId = val.school
      this.getList()
    },
    /* 公开课列表 */
    getList() {
      const data = {
        ...this.page,
        ...this.searchForm
      }
      delete data.total
      homeClient.queryOpenCourse(data).then((res) => {
        this.list = res.data.rows
        this.page.total = res.data.total
      })
    },

    goDetail(item) {
      if (this.userInfo) {
        if (item.liveCourseStatus == 0) {
          this.$message({
            type: 'error',
            message: '直播未开始'
          })
          return
        }
        if (item.liveCourseStatus == 2 && !item.playbackLink) {
          this.$message({
            type: 'error',
            message: '回放生成中'
          })
        } else {
          this.addRecord(item)
          const routeUrl = this.$router.resolve({
            path: '/publicClass/publicClassDetail',
            query: {
              id: item.openCourseId, 
            }
          })
          window.open(routeUrl.href, '_blank')
        }
      } else {
        Vue.prototype.goLoginView(true)
      }

    },

    addRecord(item) {
      const data = {
        openCourseId: item.id,
      }
      homeClient.addBrowseJxyFrequency(data).then((res) => { })
    },

    getImg() {
      homeClient.getSurfacePcList({ type: 4, entrantsType: this.domain.entrantsType }).then((res) => {
        if (res.code == 0) {
          if (res.data.length > 0) {
            this.imgList = res.data[0]
          } else {
            this.imgList = {}
          }
        }
      })

    },
    /* 搜索 */
    selectPageList() {
      this.page = {
        pageSize: 12,
        pageNum: 1,
        total: 0
      }
      this.getList()
    },
    /* 每页条数 */
    handleSizeChange(val) {
      this.page.pageSize = val
      this.page.pageNum = 1
      this.getList()
    },
    /* 当前页码 */
    handleCurrentChange(val) {
      this.page.pageNum = val
      this.getList()
    }
  }
}
</script>

<style lang="less" scoped>
.bigBox {
  width: 1220px;
  height: auto;
  margin: auto;

  .liveTips {
    width: 202px;
    margin: auto;
    font-size: #333333;
    font-size: 32px;
    font-weight: bold;
    position: relative;
    margin-top: 50px;
    margin-bottom: 32px;

    .roundTips {
      position: absolute;
      top: -10px;
      left: -10px;
      width: 40px;
      height: 40px;
      border-radius: 20px;
      background: linear-gradient(180deg,
          rgba(255, 175, 81, 0.8),
          rgba(255, 175, 81, 0.2));
    }
  }

  .videoBox {
    width: 1220px;
    height: 545px;
    border-radius: 8px;
    background-color: #222222;
    padding: 40px;
    display: flex;
    margin-bottom: 40px;

    .leftVidioBox {
      width: 720px;
      height: 465px;
      border-radius: 8px;
      margin-right: 20px;

      .video {
        width: 720px;
        height: 405px;
        border-radius: 8px 8px 0 0;
        position: relative;

        .videoContent {
          width: 100%;
          height: 100%;
        }

        .pcPictureUrl {
          width: 100%;
          height: 100%;
        }

        .cover {
          /* width: 100%;
                        height: 100%;
                        background-color: rgba(0, 0, 0, 0.5);
                        justify-content: center;
                        align-items: center; */
          position: absolute;
          top: 50%;
          left: 50%;
          margin-top: -30px;
          margin-left: -100px;
          display: none;

          .coverBtn {
            width: 200px;
            height: 60px;
            background-color: rgba(255, 94, 84, 0.8);
            border-radius: 8px;
            color: #ffffff;
            font-size: 18px;
            line-height: 60px;
            text-align: center;
            cursor: pointer;
          }
        }
      }

      .courseBox {
        width: 720px;
        height: 60px;
        border-radius: 0 0 8px 8px;
        background-color: #383838;
        padding: 20px;
        display: flex;
        align-items: center;

        .courseTitle {
          width: 410px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          margin-right: 62px;
          color: #ffffff;
        }

        .teacherBox {
          display: flex;
          align-items: center;

          .teacherImg {
            width: 32px;
            height: 32px;
            border: 1px #ffffff solid;
            border-radius: 16px;
            margin-right: 12px;
          }

          .teacherName {
            color: #ffffff;
            font-size: 14px;
            width: 104px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
        }
      }
    }

    .rightList {
      width: 400px;
      height: 465px;
      border-radius: 8px;
      background-color: #383838;
      padding: 20px 20px 0 20px;
      overflow: auto;

      .courseItem {
        cursor: pointer;
        width: 360px;
        height: 88px;
        border-radius: 8px;
        background-color: #2c2c2c;
        padding: 20px;
        margin-bottom: 12px;
        position: relative;

        .titleBox {
          margin-bottom: 16px;
          display: flex;

          .title {
            width: 257px;
            color: #ffffff;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }

        .tipsBox {
          color: rgba(255, 255, 255, 0.5);
          font-size: 12px;
          display: flex;
          justify-content: space-between;
        }

        .onCourse {
          width: 360px;
          height: 88px;
          border-radius: 8px;
          border: solid 2px #ff5e51;
          position: absolute;
          top: 0;
          left: 0;
        }
      }
    }
  }

  .searchBox {
    margin-bottom: 40px;
  }

  ::v-deep .zychoice {
    padding-left: 50px;
  }

  .courseList {
    display: flex;
    flex-wrap: wrap;

    .courstItem {
      cursor: pointer;
      width: 287px;
      height: 358px;
      border-radius: 8px;
      margin-right: 18px;
      margin-bottom: 24px;

      .itemImg {
        height: 161.44px;
        width: 287px;
        border-radius: 8px 8px 0 0;
      }

      .contentItem {
        height: 167px;
        border-radius: 0 0 8px 8px;
        background-color: #ffffff;
        padding: 12px 16px;

        .titleItem {
          color: #373a42;
          height: 48px;
          line-height: 24px;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          margin-bottom: 16px;
        }

        .timeItem {
          font-size: 14px;
          color: #999999;
          display: flex;
          justify-content: space-between;

          .loading {
            color: #ff5e51;
          }
        }

        .line {
          width: 255px;
          height: 1px;
          background-color: #eeeeee;
          margin-top: 20px;
          margin-bottom: 16px;
        }

        .teacherItem {
          color: #666666;
          font-size: 14px;
          display: flex;
          align-items: center;
          justify-content: space-between;

          .itemBox {
            display: flex;
            align-items: center;

            .teacherImgItem {
              width: 24px;
              height: 24px;
              border-radius: 12px;
              margin-right: 8px;
            }

            .ter_name {
              width: 150px;
              white-space: nowrap;
              text-overflow: ellipsis;
              overflow: hidden;
            }
          }
        }
      }
    }
  }

  .tag {
    height: 20px;
    border-radius: 3px;
    padding: 0 8px;
    line-height: 20px;
    text-align: center;
    color: #ffffff;
    font-size: 12px;
    margin-right: 8px;
  }

  .tagBack {
    background: linear-gradient(136deg, #727a8a 0%, #494e59 100%);
  }

  .tagLive {
    background: linear-gradient(138deg, #ff9a51 0%, #ff5e51 100%);
  }

  .tagNot {
    background: linear-gradient(136deg, #727a8a 0%, #555555 100%);
  }
}

.tui-img {
  margin: 0;
  width: 100%;
}
</style>
